module.exports = __webpack_public_path__ + "static/img/lgxkskkzz.5e7145c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lgxkskkzz.jpg
// module id = vtmB
// module chunks = 1